__turbopack_context__.v({
  "arrowIcon": "CourseButton-module__eXmUtW__arrowIcon",
  "buttonSpacer": "CourseButton-module__eXmUtW__buttonSpacer",
  "checkIconWrapper": "CourseButton-module__eXmUtW__checkIconWrapper",
  "ctaSection": "CourseButton-module__eXmUtW__ctaSection",
  "ctaSectionDisabled": "CourseButton-module__eXmUtW__ctaSectionDisabled",
  "selectButton": "CourseButton-module__eXmUtW__selectButton",
});
